<template>
  <div class="booking-qrCode-box">
    <div
      v-if="qrCodeBase64"
      class="booking-qrCode-img"
    >
      <img
        :src="qrCodeBase64"
        alt=""
      >
    </div>
    <div
      v-else
      class="booking-qrCode"
      id="_booking-qrCode"
      ref="signboardContent"
    >
      <div class="booking-qrCode-logo">
        <img
          src="@/assets/images/booking/logo.png"
          alt=""
        >
      </div>
      <h2 v-if="type === 'order'">
        扫描二维码立即付款
      </h2>
      <h2 v-else>
        提交成功！<br />
        扫描二维码立即绑定
      </h2>
      <h4 v-if="type === 'order'">
        Payment code
      </h4>
      <h4 v-else>
        Please scan to complete your presurgical questionnaire.
      </h4>
      <div class="booking-qrCode-main">
        <img
          @load="onLoad"
          v-if="type === 'order'"
          :src="pageInfo.pay_qr_code_url"
          alt=""
        />
        <img
          v-else
          @load="onLoad"
          :src="pageInfo.bind_qrcode_url"
          alt=""
        />
      </div>
      <p>
        {{ pageInfo.customer_name }} {{ pageInfo.customer_mobile2 }}
      </p>
      <p>
        尊敬的客户，您可用微信扫一扫识别，也可在微信中长按图片识别
      </p>
    </div>
    <div
      v-show="btnShow"
      class="booking-qrCode-download"
      @click="download"
    >
      <img
        src="@/assets/images/booking/download.png"
        alt=""
      >
    </div>
  </div>

</template>

<script>
import html2canvas from "html2canvas";
import bookingService from "@/apis/booking";
import menZhenService from "@/apis/menZhen/index.js";
import enums from "@/views/booking/mixins/enums";
import * as dd from "dingtalk-jsapi";
import { Toast } from "vant";

export default {
  data() {
    return {
      btnShow: true,
      pageInfo: {},
      type: "order",
      qrCodeBase64: "",
    };
  },
  watch: {
    currentUserInfo: {
      handler(newVal) {
        console.log(newVal);
        // 获取到当前登录用户信息
        // if (newVal.user_id) {
        const type = this.$route.query.type;
        if (type === "order") {
          this.getOrderInfo();
        } else if (type === "apply") {
          this.getApplyInfo();
        } else if (this.$route.query.work_id) {
          this.workMyWorkDetail();
        }
        // }
      },
      immediate: true,
      deep: true,
    },
  },
  mixins: [enums],

  created() {
    if (this.$route.query.work_id) {
      this.type = "apply";
    } else {
      this.type = this.$route.query.type;
    }
  },
  methods: {
    getOrderInfo() {
      const params = {
        order_id: this.$route.query.id,
        create_user_id:
          this.currentUserInfo.user_id || this.$route.query.userId,
      };
      bookingService.getOrderInfo(params).then((res) => {
        this.pageInfo = res;
        this.initImg();
      });
    },
    getApplyInfo() {
      const params = {
        apply_id: Number(this.$route.query.id),
        submit_user_id:
          this.currentUserInfo.user_id || this.$route.query.userId,
      };
      bookingService.applyInfo(params).then((res) => {
        this.pageInfo = res;
        this.initImg();
      });
    },
    workMyWorkDetail() {
      const params = {
        work_id: this.$route.query.work_id,
      };
      menZhenService.workDetail(params).then((res) => {
        this.pageInfo = res;
        this.initImg();
      });
    },
    initImg() {},
    onLoad() {
      this.$nextTick(() => {
        this.exportImage();
      });
    },

    download() {
      if (dd.env.platform !== "notInDingTalk") {
        Toast("长按保存");
        return;
      }
      // this.btnShow = false;
      this.$nextTick(() => {
        const name = this.pageInfo.customer_name;
        let a = document.createElement("a");

        let blob = this.dataURLToBlob(this.qrCodeBase64);
        a.setAttribute("href", URL.createObjectURL(blob));
        a.setAttribute("download", `${name}.png`);

        a.click();
        URL.revokeObjectURL(blob);
      });
    },
    dataURLToBlob(dataurl) {
      //ie 图片转格式
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    exportImage() {
      let canvasID = this.$refs.signboardContent;
      html2canvas(canvasID, {
        useCORS: true,
      })
        .then((canvas) => {
          // console.log(canvas);
          this.qrCodeBase64 = canvas.toDataURL("image/png");
        })
        .finally(() => {
          this.btnShow = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-qrCode {
  height: 100vh;
  background: url("./../../assets/images/booking/qrCode_bg.png");
  background-size: 100% 100%;
  padding: 20px;
  box-sizing: border-box;

  color: #eaeaea;
  h2 {
    font-weight: 500;
    font-size: 24px;

    line-height: 32px;
    padding-bottom: 10px;
    padding-right: 30px;
    display: inline-block;

    border-bottom: 2px solid #da0032;
    margin: 0;
    margin-top: -10px;
  }
  h4 {
    font-weight: 400;
    font-size: 15px;
    margin: 0;
    margin-top: 10px;
    font-family: Johnston100W03-Medium-Regular, Johnston100-W03-Medium;
  }
  p {
    font-size: 16px;

    font-weight: 400;
    margin: 12px 0;
  }
}
.booking-qrCode-main {
  text-align: center;
  margin-top: 40px;
  margin-bottom: 40px;
  img {
    width: 80%;
    border-radius: 15px;
  }
}
.booking-qrCode-logo {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  img {
    width: 72px;
    height: 72px;
  }
}
.booking-qrCode-download {
  position: fixed;
  bottom: 50px;
  right: 20px;
  width: 68px;
  height: 68px;
  cursor: pointer;
  img {
    width: 100%;
  }
}
.booking-qrCode-img {
  img {
    width: 100%;
  }
}
</style>